<template>
  <div class="promptPopups">
    <div class="promptPopups-main">
      <div class="promptPopups-main-logo"></div>
      <div class="alert-content">
        请先确认条款后，再进行预订
      </div>
      <div class="alert-btn">
        <div class="alert-btn-left" @click="cancleFn">返回退出</div>
        <div class="alert-btn-right" @click="confirmFn">继续确认</div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  props: {
    hasNrp: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      hasNrpContent: '',
    }
  },
  
  computed: {},
  methods: {
    cancleFn() {
      this.$emit('cancleFn')
    },
    confirmFn() {
      this.$emit('confirmFn')
    },
  }
}
</script>
<style scoped lang="less">
.promptPopups {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 3001;
  background-color: rgba(0, 0, 0, 0.34);
  /* padding: 0 74rpx; */

  .promptPopups-main {
    width: 500px;
    height: 240px;
    background: #FFFFFF;
    border-radius: 10px;
    background-color: #ffffff;
    box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.1);
    //border-radius: 16px;
    box-sizing: border-box;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;

    .promptPopups-main-logo {
      text-align: center;
      font-size: 20px;
      color: #f8c233;
      width: 80px;
      height: 77px;
      background: url("https://resource.rcclchina.com.cn/logo/PC/logoPopup.png") no-repeat;
      background-size: 100% 100%;
      margin: 18px auto 12px;
    }

    .alert-content{
      font-weight: 400;
      font-size: 24px;
      color: #464646;
      line-height: 48px;
      text-align: center;
      font-style: normal;
      margin-bottom: 15px;
    }

    .alert-btn{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 50px;
    }

    .alert-btn-left{
      width: 170px;
      height: 46px;
      background: #EAEAEA;
      border-radius: 12px;
      font-weight: 500;
      font-size: 20px;
      color: #000000;
      line-height: 43px;
      text-align: center;
      font-style: normal;
      cursor: pointer;
    }

    .alert-btn-right{
      width: 170px;
      height: 46px;
      background: #FCC300;
      border-radius: 12px;
      font-weight: 500;
      font-size: 20px;
      color: #000000;
      line-height: 43px;
      text-align: center;
      font-style: normal;
      cursor: pointer;
      
    }

    
  }
}
</style>
